import React from "react";
import { Button } from "react-bootstrap";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { FaCloudDownloadAlt } from "react-icons/fa";
import logo from "../assets/logo.png";


const flattenObject = (obj, prefix = "") => {
  return Object.keys(obj).reduce((acc, k) => {
    const key = prefix ? `${prefix} ${k.replace(/_/g, " ")}` : k.replace(/_/g, " ");
    if (obj[k] && typeof obj[k] === "object" && !Array.isArray(obj[k])) {
      Object.assign(acc, flattenObject(obj[k], key));
    } else {
      acc[key.charAt(0).toUpperCase() + key.slice(1)] = obj[k] || "N/A";
    }
    return acc;
  }, {});
};

const PdfDownloader = ({ formData, loanId }) => {
  const handleDownload = () => {
    const doc = new jsPDF();

    // Determine loan type based on loanId prefix
    let loanType = "";
    if (loanId.startsWith("HL")) loanType = "Home Loan";
    else if (loanId.startsWith("PL")) loanType = "Personal Loan";
    else if (loanId.startsWith("BL")) loanType = "Business Loan";
    else if (loanId.startsWith("ML")) loanType = "Mortgage Loan";
    else if (loanId.startsWith("DL")) loanType = "Doctor Loan";
    else if (loanId.startsWith("NRI")) loanType = "NRI Loan";
    else loanType = "Loan";

    const img = new Image();
    const pageImageWidth = doc.internal.pageSize.getWidth();
    img.src = logo;
    doc.addImage(img, "PNG", pageImageWidth - 45, 8, 30, 10);

    doc.setFont("helvetica", "bold");
    doc.setFontSize(20); 
    const text = `${loanType}`;
    const textWidth = doc.getTextWidth(text);
    const pageWidth = 210; // A4 width in mm (default jsPDF page size)
    const x = (pageWidth - textWidth) / 2; // Center the text
    doc.text(text, x, 20);

    // Convert formData to array of key-value pairs
    const tableData = Object.entries(formData).map(([key, value]) => [
        key.replace(/_/g, " ").charAt(0).toUpperCase() + key.replace(/_/g, " ").slice(1),
        value || "N/A",
      ]);

     let startY = 30; // initial Y

    // Add each section
    formData.forEach((section) => {
      if (section.data && Object.keys(section.data).length > 0) {
        // Section title
        doc.setFontSize(14);
        doc.setTextColor(41, 128, 185); // blue color
        doc.text(section.title, 14, startY);
        startY += 6;

        // Flatten data
        const normalizeText = (text) => {
          if (text === null || text === undefined) return "N/A";
          return String(text)
            .normalize("NFD")                     // Decompose accented characters
            .replace(/[\u0300-\u036f]/g, "")      // Remove diacritics
            .replace(/\s+/g, " ")                 // Clean extra spaces
            .trim();
        };

        const tableData = flattenObject(section.data);
        const rows = Object.entries(tableData).map(([key, value]) => [
          key.replace(/_/g, " ").charAt(0).toUpperCase() + key.replace(/_/g, " ").slice(1),
          normalizeText(value),
        ]);


        autoTable(doc, {
          startY,
          body: rows,
          headStyles: { fillColor: [41, 128, 185], halign: "center", fontSize: 12 },
          columnStyles: {
            0: { cellWidth: 90 },
            1: { cellWidth: 90 },
          },
        });

        startY = doc.lastAutoTable.finalY + 8;
      }
    });

    // Determine file name based on loanId prefix
    let fileName = "";
    if (loanId.startsWith("HL")) fileName = `home_loan_${loanId}.pdf`;
    else if (loanId.startsWith("PL")) fileName = `personal_loan_${loanId}.pdf`;
    else if (loanId.startsWith("BL")) fileName = `business_loan_${loanId}.pdf`;
    else if (loanId.startsWith("ML")) fileName = `mortgage_loan_${loanId}.pdf`;
    else if (loanId.startsWith("DL")) fileName = `doctor_loan_${loanId}.pdf`;
    else if (loanId.startsWith("NRI")) fileName = `nri_loan_${loanId}.pdf`;
    else fileName = `loan_${loanId}.pdf`; 

    doc.save(fileName);
  };

  return (
    <Button
      size="sm"
      onClick={handleDownload}
      className="pdf-button"
    >
      <FaCloudDownloadAlt /> Download
    </Button>
  );
};

export default PdfDownloader;